export default [
    {
        value: "RelatorioMensal",
        text: "Relatório mensal",
        subtipo : "RelatorioMensal",
    },
    {
        value: "RelatorioAtividades",
        text: "Relatório de atividades",
        subtipo : "BoletimMedicao",
    },
    {
        value: "RelatorioFinanceiro",
        text: "Relatório financeiro",
        subtipo : "RelatorioParcial",
    },    
    {
        value: "RelatorioTecnico",
        text: "Relatório técnico",
        subtipo : "RelatorioParcial",
    },
    {
        value: "RelatorioFinal",
        text: "Relatório final",
        subtipo : "RelatorioFinal",
    },
]